import { Component, EventEmitter, Input, Output } from '@angular/core';
var HTML_TEMPLATE = "\n<div class=\"od-creation-form\">\n\t<ion-list *ngIf=\"datas !=null\" class=\"od-creation-form\">\n\t\t<ion-item *ngFor=\"let data of datas\" no-lines>\n\t\t\t<od-button [text]=\"data.name\" [iconName]=\"data.iconName\" [file]=\"data.file\" [color]=\"buttonTextColor\" [bgColor]=\"buttonColor\" (click)=\"onCreate(data)\"  class=\"od-creation-form-btn\"></od-button>\n\t\t</ion-item>\n\t</ion-list>\n<div>\n";
var CSS_STYLE = "\n.od-creation-form{\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmin-height: fit-content;\n    flex-direction: column;\n}\n.od-creation-form-btn {\n    display: flex;\n    width: fit-content;\n    width: -moz-max-content;\n    margin: auto;\n}\n";
var CreationForm = /** @class */ (function () {
    function CreationForm() {
        this.odCreate = new EventEmitter();
        if (this.buttonColor == null)
            this.buttonColor = "#25aed8";
        if (this.buttonTextColor == null)
            this.buttonTextColor = "#FFFFFF";
    }
    CreationForm.prototype.onCreate = function (data) {
        this.odCreate.emit(data);
    };
    CreationForm.decorators = [
        { type: Component, args: [{
                    selector: 'od-creation-form',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    CreationForm.ctorParameters = function () { return []; };
    CreationForm.propDecorators = {
        "datas": [{ type: Input },],
        "buttonTextColor": [{ type: Input },],
        "buttonColor": [{ type: Input },],
        "odCreate": [{ type: Output },],
    };
    return CreationForm;
}());
export { CreationForm };
//# sourceMappingURL=creation-form.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui/creation-form/creation-form.js
// module id = 448
// module chunks = 14